import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import Motion from '@/app/components/Motion';

export const EidHeroBackground = () => {
  return (
    <Motion
      className="relative z-10 h-full"
      animate={{ opacity: 1, scale: 1 }}
      initial={{ opacity: 0, scale: 1.1 }}
      transition={{ duration: 1.5, type: 'tween' }}
      data-cy="eid-hero-background"
    >
      <ArtDirectionImage
        className="object-cover"
        fill
        localizedAlt="eid_hero_background_alt"
        priority
        sizes="100vw"
        srcSet={[
          {
            media: '(max-width: 767px)',
            src: 'or4_gold_cloud_hero.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.6&fp-z=1.5&rot=270',
          },
          {
            media: '(min-width: 767px)',
            src: 'or4_gold_cloud_hero.png?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.38&fp-y=0.51&fp-z=1.7',
          },
        ]}
      />
    </Motion>
  );
};
